import { createAsyncThunk } from '@reduxjs/toolkit';
import eventDashboardApi from '@infrastructure/event-dashboard';
import { getErrorPayload } from '@application/helpers/api-helper';
export const getEventFormSteps = createAsyncThunk('eventDashboard/getEventFormSteps', async (id, { rejectWithValue }) => {
    try {
        const response = await eventDashboardApi.getEventFormSteps(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEventFormStepFields = createAsyncThunk('eventDashboard/getEventFormStepFields', async (id, { rejectWithValue }) => {
    try {
        const response = await eventDashboardApi.getEventFormStepFields(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEventFormStepsAndFields = createAsyncThunk('eventDashboard/getEventFormStepsAndFields', async (id, { rejectWithValue }) => {
    try {
        const response = await eventDashboardApi.getEventFormStepsAndFields(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateDashboardResponseGrid = createAsyncThunk('eventDashboard/updateDashboardResponseGrid', async (data, { rejectWithValue }) => {
    try {
        const response = await eventDashboardApi.updateDashboardResponseGrid(data);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
